import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import { ContentWithStickyHeader } from '@sorare/core/src/atoms/layout/ContentWithStickyHeader';
import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import {
  ANY_SPORT_PLAY_EVENTTYPE_FIXTURE,
  ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_REWARDS,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useNewLobbyFF } from '@sorare/core/src/hooks/useNewLobbyFF';
import { glossary } from '@sorare/core/src/lib/glossary';

type Props = {
  so5FixtureSlug: string;
  eventType: So5FixtureEvent;
  children: ReactNode;
};

export const FixtureTabLayout = ({
  so5FixtureSlug,
  eventType,
  children,
}: Props) => {
  const useNewLobby = useNewLobbyFF();
  const { generateSportContextPath } = useSportContext();
  if (!useNewLobby) {
    return children;
  }
  return (
    <ContentWithStickyHeader
      header={
        <FullWidthContainer.NoPadding>
          <TabBar variant="flat" fullWidth>
            <Tab
              to={generateSportContextPath(ANY_SPORT_PLAY_EVENTTYPE_FIXTURE, {
                params: {
                  fixture: so5FixtureSlug,
                  eventType: eventType.toLowerCase(),
                },
              })}
            >
              <FormattedMessage {...glossary.lineups} />
            </Tab>
            <Tab
              to={generateSportContextPath(
                ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_REWARDS,
                {
                  params: {
                    fixture: so5FixtureSlug,
                    eventType: eventType.toLowerCase(),
                  },
                }
              )}
            >
              <FormattedMessage {...glossary.rewards} />
            </Tab>
          </TabBar>
        </FullWidthContainer.NoPadding>
      }
    >
      {children}
    </ContentWithStickyHeader>
  );
};
